import React from 'react';
import { Box, Typography, Container } from '@mui/material';
import { motion } from 'framer-motion';
import Button from '../common/Button';
import heroMain from '../../assets/hero/hero-main.png';
import heroElement from '../../assets/hero/hero-element.webp';
import dashboardScreenshot from '../../assets/hero/dashboard-screenshot.png';

const HeroSection: React.FC = () => {
  return (
        <Box
          component="section"
          sx={{
            overflow: 'hidden',
            width: '100%',
          }}
        >
      <Container maxWidth="xl" sx={{  width: '90%' }}>
        <Box sx={{ display: 'flex', gap: 6, alignItems: 'center', flexDirection: { xs: 'column', md: 'row' } }}>
          {/* LEFT: Text and button */}
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.5 }}
            style={{ flex: 1 }}
          >
            <Typography variant="h1" sx={{ fontSize: 48, fontWeight: 700, color: '#070707', mb: 2 }}>
              Fintech Software Development Company AKRBIT
            </Typography>
            <Typography sx={{ fontSize: 18, color: '#070707', mb: 4 }}>
              Ready made E-wallet, Payment Gateway, Crypto Exchange platform or software developing from scratch for your business needs.
            </Typography>
            <Button variant="cyan" href="mailto:official@akrbit.com">Contact us</Button>
          </motion.div>

          {/* RIGHT: 3 images */}
          <motion.div
            initial={{ opacity: 0, x: 50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.5, delay: 0.2 }}
            style={{ flex: 1, display: 'flex', alignItems: 'flex-start', justifyContent: 'center' }}
          >
            <Box sx={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'center' }}>
              <Box
                component="img"
                src={heroMain}
                alt="Fintech"
                sx={{
                  width: '40%',
                  height: 'auto',
                  borderRadius: '8px',
                  position: 'relative',
                  zIndex: 2,
                  mr: '-40px',
                  boxShadow: '0px 16px 32px 0px rgba(87, 84, 255, 0.11)',
                }}
              />
              <Box
                component="img"
                src={heroElement}
                alt="Element"
                sx={{
                  width: '144px',
                  height: '144px',
                  position: 'relative',
                  zIndex: 1,
                  mt: '-20px', // Adjusted to be "a bit higher"
                }}
              />
              <Box
                component="img"
                src={dashboardScreenshot}
                alt="Dashboard"
                sx={{
                  width: '40%',
                  height: 'auto',
                  borderRadius: '8px',
                  borderStyle: 'solid',
                  borderWidth: '1px',
                  borderColor: '#E4EAFF',
                  position: 'relative',
                  zIndex: 2,
                  ml: '-40px',
                  boxShadow: '0px 16px 32px 0px rgba(0, 0, 0, 0.04)',
                }}
              />
            </Box>
          </motion.div>
        </Box>
      </Container>
    </Box>
  );
};

export default HeroSection;
